import React, { useRef, useState, useEffect } from "react";
export default function Philosophy() {
  const headingRef = useRef<HTMLHeadingElement>(null);
  const textRef = useRef<HTMLDivElement>(null);
  const [headingVisible, setHeadingVisible] = useState(false);
  const [textVisible, setTextVisible] = useState(false);
  useEffect(() => {
    const headingObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setHeadingVisible(true);
        }
      });
    }, {
      threshold: 0.1
    });
    const textObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setTextVisible(true);
        }
      });
    }, {
      threshold: 0.1
    });
    if (headingRef.current) {
      headingObserver.observe(headingRef.current);
    }
    if (textRef.current) {
      textObserver.observe(textRef.current);
    }
    return () => {
      headingObserver.disconnect();
      textObserver.disconnect();
    };
  }, []);
  return <section id="philosophy" className="relative !bg-[hsl(33,21%,81%)] ![padding:96px_0px_96px_0px]">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
        <div className="text-center space-y-8">
          <p className="mb-2 text-[14px] font-medium uppercase tracking-[0.1em] text-[#8b6e4c]">
            OUR PHILOSOPHY
          </p>

          <h2 ref={headingRef} className={`font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground tracking-wide transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            Luxury Is in the Details
          </h2>

          <div ref={textRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-100 ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <p className="text-base md:text-lg text-foreground/80 leading-relaxed text-center font-sans">
              At <span className="font-semibold">KS LUXURY RENOVATIONS</span>, we
              believe luxury is not about excess — it is about <br />
              <span className="font-semibold">
                clarity, craftsmanship, and intention.
              </span>
              <br />
              <br />
              Every line, surface, and material choice is deliberate. <br />
              Every project is treated with the same level of care, regardless of
              scale.
              <br />
              <br />
              <span className="font-bold">Our goal is simple: </span>
              <br />
              to create spaces that feel effortless to live and work in — and
              exceptional to experience.
            </p>
          </div>
        </div>
      </div>
    </section>;
}